// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"967fca71","806":"7569a1ca"}[chunkId] + ".chunk.js";
};